import { createApp } from 'vue'
import App from './App.vue'

import '@/assets/scss/bootstrap-custom.scss'
import '@/assets/global.scss'

createApp(App).mount('#app')
